import { createClient } from '@supabase/supabase-js'

import { STORAGE_BUCKET_KEY } from '@/constants/supabase/supabase'
import { env } from '@/env'
import { tryCatch } from '@/lib/try-catch'
import { vanillaApiClient } from '@/trpc/vanilla'

interface UploadToSignedUrlArgs {
  file: string
}

const uploadToSignedUrl = async ({ file }: UploadToSignedUrlArgs) => {
  const client = createClient(
    env.NEXT_PUBLIC_SUPABASE_URL!,
    env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  )
  // Convert the encrypted string to Uint8Array
  const encoder = new TextEncoder()
  const data = encoder.encode(file)

  const { data: signedUrl, error: signedUrlError } = await tryCatch(
    vanillaApiClient.storage.getSignedUrl.query(),
  )

  if (signedUrlError) {
    throw new Error('Failed to get signed URL')
  }

  const { data: uploadedData, error: uploadError } = await client.storage
    .from(STORAGE_BUCKET_KEY)
    .uploadToSignedUrl(
      signedUrl.path,
      signedUrl.token,
      new Blob([new Uint8Array(data.buffer)]),
    )

  return { data: uploadedData, error: uploadError }
}

export default uploadToSignedUrl
